import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import '../styles/complete-registration.css'; // reaproveita estilos
import bg from '/ai3-home-bg1.webp';

const ResetPassword = () => {
  const [token, setToken] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [strength, setStrength] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState('');
  const navigate = useNavigate();
  const { search } = useLocation();

  // extrai token da URL
  useEffect(() => {
    const t = new URLSearchParams(search).get('token');
    if (!t) {
      setError('Token não fornecido.');
    } else {
      setToken(t);
    }
  }, [search]);

  // valida e mede força da senha
  const validatePassword = (pass) => {
    const rules = [/.{8,}/, /[A-Z]/, /[a-z]/, /[0-9]/, /[!@#$%^&*()_+{}\[\]:;<>,.?~\\\/-]/];
    const passed = rules.filter((r) => r.test(pass)).length;
    if (passed <= 2) return 'Fraca';
    if (passed <= 4) return 'Média';
    return 'Forte';
  };
  useEffect(() => setStrength(validatePassword(newPassword)), [newPassword]);

  const handleReset = async (e) => {
    e.preventDefault();
    if (newPassword !== confirmPassword) {
      setError('Senhas não coincidem.');
      return;
    }
    setError('');
    setLoading(true);
    try {
      await axios.post(
        `${import.meta.env.VITE_BACKEND_URL}/reset-password`,
        { token, newPassword }
      );
      setSuccess('Senha redefinida! Redirecionando ao login...');
      setTimeout(() => navigate('/login'), 2000);
    } catch (e) {
      setError(e.response?.data?.error || 'Erro ao redefinir senha.');
    } finally {
      setLoading(false);
    }
  };

  const backgroundStyle = {
    background: `url(${bg}) center/cover`,
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  };

  return (
    <div style={backgroundStyle}>
      <form className="register-form" onSubmit={handleReset}>
        <img src="/logo_viadrive.svg" alt="Logo" className="logo-register" />
        <h2>Redefinir Senha</h2>

        {error && <div className="error-message">{error}</div>}
        {success && <div className="success-message">{success}</div>}

        <div className="password-row">
          <input
            type={showPassword ? 'text' : 'password'}
            placeholder="Nova senha"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            required
            disabled={loading}
          />
          <span onClick={() => setShowPassword((v) => !v)}>
            {showPassword ? <FaEyeSlash /> : <FaEye />}
          </span>
        </div>
        {newPassword && (
          <div className={`strength ${strength.toLowerCase()}`}>Senha {strength}</div>
        )}

        <input
          type={showPassword ? 'text' : 'password'}
          placeholder="Confirmar senha"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          required
          disabled={loading}
        />

        {/* regras de senha */}
        <ul className="password-rules">
          <li>Mínimo de 8 caracteres</li>
          <li>Uma letra maiúscula</li>
          <li>Uma letra minúscula</li>
          <li>Um número</li>
          <li>Um caractere especial</li>
        </ul>

        <button type="submit" disabled={loading}>
          {loading ? 'Redefinindo...' : 'Redefinir Senha'}
        </button>
      </form>
    </div>
  );
};

export default ResetPassword;
